export const MODEL_TYPES = {
  TOOL: 'TOOL',
  SCALING: 'SCALING',
} as const;

export type ModelType = typeof MODEL_TYPES[keyof typeof MODEL_TYPES];

export const EDITED_FEATURE_TYPE = 'FEATURE_ID';

export type ModelInputIds = { inputFeatureId?: string; referenceId?: string; id?: string };
